import RecipeDetails from '../components/RecipeDetails';

function MealsDetails() {
  return (
    <RecipeDetails />
  );
}

export default MealsDetails;
